import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import ValidI18nMessage from 'marketplace-ui-common/i18n/components/ValidI18nMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICardHeader from 'UIComponents/card/UICardHeader';
import UICardSection from 'UIComponents/card/UICardSection';
import UICardWrapper from 'UIComponents/card/UICardWrapper';
import UIRibbon from 'UIComponents/ribbon/UIRibbon';
import { validUnescapedText } from 'marketplace-ui-common/i18n/utils';
export default function ThemeCollectionCard({
  className,
  collection
}) {
  if (!collection.publishedListing) {
    return null;
  }

  const collectionId = collection.id;
  return /*#__PURE__*/_jsxs(UICardWrapper, {
    className: className,
    compact: true,
    children: [/*#__PURE__*/_jsx(UIRibbon, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.storefront.themes.themeCollectionLabel"
      })
    }), /*#__PURE__*/_jsx(UICardHeader, {
      className: "m-top-4",
      title: validUnescapedText(`marketplace-assets-ui.collections.collection_${collectionId}.title`, {}, collection.publishedListing.title),
      titleSize: "small"
    }), /*#__PURE__*/_jsx(UICardSection, {
      children: /*#__PURE__*/_jsx(ValidI18nMessage, {
        defaultValue: collection.publishedListing.description,
        message: `marketplace-assets-ui.collections.collection_${collectionId}.description`,
        messageComponent: FormattedHTMLMessage
      })
    })]
  });
}